import { Stack, Typography } from '@mui/material';
import { EmailSentIcon } from '@icons/EmailSentIcon';
import { refineFonts } from '@/Theming/refineFonts';
import { FC, useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';

interface IEmailSentSuccessfullyProps {
	email: string;
}

export const EmailSentSuccessfully: FC<IEmailSentSuccessfullyProps> = ({ email }) => {
	const { EmailSentSuccessfully } = useContext(LocalizationContext);
	const { Title, Subtitle, Message } = EmailSentSuccessfully;

	return (
		<Stack
			data-cy={'pqEmailSuccessfullySentScreen'}
			paddingTop={'50px'}
			gap={'16px'}
			alignItems={'center'}
			height={'100%'}
			width={'100%'}>
			<EmailSentIcon />
			<Typography textAlign={'center'} sx={{ ...refineFonts.h4Bold }}>
				{Title}
			</Typography>
			<Typography textAlign={'center'} sx={{ ...refineFonts.largeRegular }}>
				{Subtitle.replace('%1$s', email)}
			</Typography>
			<Typography textAlign={'center'} marginTop={'16px'} sx={{ ...refineFonts.largeRegular }}>
				{Message}{' '}
			</Typography>
		</Stack>
	);
};
